import script from "./DetailHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailHistory.vue?vue&type=script&setup=true&lang=js"

import "./DetailHistory.vue?vue&type=style&index=0&id=bf550b1a&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf550b1a"]])

export default __exports__